<template>
    <div class="main-content">
        <section class="section sec-style mt-5">
            <div class="section-body">

                <template v-if="loading === false">
                    <event-link :detail_event="detail_event" @alertPackage="alertPackage"></event-link>

                    <div class="row row-step-w">
                        <div class="col-md-12">
                            <div class="wizard-steps wizard-appearance">
                                <div v-for="(data,index) in menu_event"
                                    :key="index" :class="data.component === menu_active ? 'wizard-step-active' : ''"
                                    class="wizard-step"
                                    v-on:click="menu_active = data.component"
                                >
                                    <div class="wizard-step-icon">
                                        <i :class="data.icon"></i>
                                    </div>
                                    <div class="wizard-step-label">
                                        {{data.name}}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-7 col-event">
                            <component :is="menuWebsite" :detail_event="detail_event" :menu_active="menu_active" @alertPackage="alertPackage"></component>
                        </div>

                        <event-frame :detail_event="detail_event"></event-frame>

                    </div>
                </template>

                <div v-if="loading === true" class="row mt-5">
                    <div class="col-12 text-center mt-3">
                        <div class="half-circle-spinner">
                            <div class="circle circle-1"></div>
                            <div class="circle circle-2"></div>
                        </div>
                    </div>
                </div>

            </div>
        </section>
    </div>
</template>

<script>
    import { mapActions, mapState, mapMutations } from 'vuex'
    import EventLink from '../appearance/EventLink.vue'
    import EventFrame from '../appearance/EventFrame.vue'

    export default {
        data(){
            return{
                loading:false,
                menu_event: [
                    {id:'1',name:'Theme',component: 'Theme',icon:'uil uil-web-grid-alt'},
                    {id:'3',name:'Basic Setup',component: 'Basic',icon:'uil uil-file-info-alt'},
                    {id:'2',name:'Persons',component: 'Person',icon:'uil uil-users-alt'},
                    {id:'4',name:'Gallery',component: 'Gallery',icon:'uil uil-images'},
                    {id:'5',name:'Schedule',component: 'Schedule',icon:'uil uil-schedule'},
                    {id:'5.1',name:'Story',component: 'Story',icon:'uil uil-history'},
                    {id:'5.2',name:'Payment',component: 'Payment',icon:'uil uil-credit-card'},
                    {id:'6',name:'Setting',component: 'Setting',icon:'uil uil-setting'},
                    // {id:'7',name:'Styles',component: Advance,icon:'uil uil-palette'},
                ],
                menu_active:'Theme',
            }
        },
        mounted(){
            this._detailEvents()
        },
        components: {
            EventLink,
            EventFrame
        },
        computed:{
            ...mapState('EventsControl', {
                detail_event: state => state.detail_event,
            }),
            ...mapState('AuthControl', {
                user: state => state.user,
            }),

            menuWebsite () {
                let menu = this.menu_active
                return () => import(`../appearance/componentEvent/${menu}`)
            },

        },
        methods:{
            ...mapActions('EventsControl', ['detailEvents']),
            ...mapMutations('EventsControl', ['CLEAR_DETAIL_EVENT']),

            _detailEvents: function(){
                this.loading = true
                this.detailEvents(this.$route.params.id).then((res) => {
                    if(res.status == 1){
                        this.$router.push({ name: '404' })
                    }else if(res.status == 0 && this.user.level == 3 && this.user.id !== res.agent_id){
                        this.$router.push({ name: '404' })
                    }else if(res.message === 'Not Found'){
                        this.$router.push({ name: '404' })
                    }else{
                        this.loading = false
                    }
                })
            },
            alertPackage: function(){
                this.$toast.warning('Sorry, Upgrade your package to premium event to use this feature')
            }
        },
        beforeRouteEnter(to, from, next){
            next(vm => {
                if(vm.user.level === '2'){
                    vm.$router.push({ name: '404' })
                }
            })
        },
        destroyed(){
            this.CLEAR_DETAIL_EVENT()
        }
    }

</script>
